import { render, staticRenderFns } from "./PreviousDecursus.vue?vue&type=template&id=08016c1e"
import script from "./PreviousDecursus.vue?vue&type=script&lang=js"
export * from "./PreviousDecursus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports